import {noop} from 'lodash';
import {connect} from 'react-redux';

import {TagBehaviorsEnum} from '../../../../../libs/shared/core/src/models/api/commonTagModel';
import {TeamModel} from '../../../../../libs/shared/core/src/models/api/teamModel';
import {createSelector, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {getCompany} from '../../../../store/data/company/companySelectors';
import {getTags} from '../../../../store/data/tags/tagsSelectors';
import {getUserNamespace} from '../../../../store/data/teammates/teammatesSelectors';
import {ToggleDropdownTeamCustomViewHandler, workspacesEditorDropdownWidth} from '../editor/context/types';
import {PickTagsDropdown, ToggleTagHandler} from './pickTagsDropdown';

/*
 * Props.
 */

interface PickTagsDropdownContainerProps {
  team: TeamModel;
  onToggleTeamCustomView: ToggleDropdownTeamCustomViewHandler;
  visibleTeamCustomViewIds: Array<number>;
}

/*
 * Selectors.
 */

function getTeam(_state: AppState, props: PickTagsDropdownContainerProps) {
  return props.team;
}

function makeGetNamespace() {
  return createSelector([getTeam, getUserNamespace], (team, userNamespace) =>
    team ? team.namespace : userNamespace,
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<PickTagsDropdownContainerProps>()(() => {
  const getNamespace = makeGetNamespace();
  return {
    company: getCompany,
    namespace: getNamespace,
    tags: getTags,
  };
});

/**
 * This component is adapted from the now-removed <PickTagsDropdownContainer /> but for use in <WorkspacesEditor />.
 * This is specifically for custom views in team workspaces.
 */
export const WorkspacesEditorPickTeamViewsDropdownContainer = connect(
  mapStateToProps,
  {},
  (stateProps, dispatchProps, ownProps) => {
    const {onToggleTeamCustomView, team} = ownProps;

    const toggleTag: ToggleTagHandler = (searchTag) => {
      // This check is just to be safe so the code won't crash. searchTag in this case should always
      // be length 1 and contain the tag representing the custom view.
      if (searchTag.length > 0) {
        const tag = searchTag[0];
        if (tag) {
          onToggleTeamCustomView(tag, team.id);
        }
      }
    };

    return {
      ...stateProps,
      ...ownProps,
      toggleTag,
      backButtonLabel: null,
      onBackButtonClick: noop,
      isEditingWorkspace: true,
      visibleCustomViewIds: ownProps.visibleTeamCustomViewIds,
      shouldDisplayHideAllButton: false,
      behaviors: [TagBehaviorsEnum.CAN_CUSTOM_VIEW],
      width: workspacesEditorDropdownWidth,
      shouldDisplayAddButton: false,
    };
  },
)(PickTagsDropdown);
